// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import "./assets/css/common.css"
import "./assets/css/main.css"
import VueCropper from "vue-cropper"
import Uploader from "vue-uploader"
import store from "./store"
import VueLazyload from 'vue-lazyload'
Vue.config.productionTip = false
Vue.use(VueCropper)
Vue.use(Uploader);
Vue.use(VueLazyload,{
  loading: require('./assets/img/bg_default.png')
});

import header from "@/components/common/topmenu.vue"
import footer from "@/components/common/bottom.vue"
Vue.component("my-header",header);
Vue.component('my-footer',footer);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js